/* =====================================================================
   CALDRENE motion layer (22/10/2026)
   GSAP + ScrollTrigger for scroll choreography, Three.js for the hero helix.
   Every effect is optional: without the libraries, or with reduced motion,
   the page renders complete and static.
   ===================================================================== */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var G = function () { return typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined'; };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* ---------- preloader ---------- */
  function intro() {
    var pre = $('#cdPre');
    var heroLines = $$('.cd-hero .cd-ln > span'), heroIn = $$('.cd-hero-in');
    if (!pre) {
      if (G() && !reduce && heroLines.length) {
        gsap.from(heroLines, { yPercent: 110, duration: 1.2, ease: 'expo.out', stagger: .12 });
        gsap.from(heroIn, { opacity: 0, y: 24, duration: 1, ease: 'power3.out', stagger: .1, delay: .2 });
      }
      return;
    }
    if (!G() || reduce) { pre.style.display = 'none'; return; }
    pre.style.animation = 'none';
    var num = $('#cdPreNum'), o = { v: 0 };
    gsap.timeline()
      .to(o, { v: 100, duration: 1.6, ease: 'power2.inOut', onUpdate: function () { num.textContent = String(Math.round(o.v)).padStart(3, '0'); } })
      .to('.cd-pre__mid', { opacity: 0, y: -20, duration: .4 })
      .to('.cd-pre__pan--t', { yPercent: -100, duration: 1, ease: 'expo.inOut' }, '<.1')
      .to('.cd-pre__pan--b', { yPercent: 100, duration: 1, ease: 'expo.inOut' }, '<')
      .set(pre, { display: 'none' })
      .from(heroLines, { yPercent: 110, duration: 1.2, ease: 'expo.out', stagger: .12 }, '-=.55')
      .from(heroIn, { opacity: 0, y: 24, duration: 1, ease: 'power3.out', stagger: .1 }, '-=.9');
  }

  /* ---------- cursor + magnetic buttons ---------- */
  function cursor() {
    if (!fine || reduce) return;
    var cur = $('.cd-cur'), dot = $('.cd-cur-dot');
    if (!cur || !dot) return;
    var mx = innerWidth / 2, my = innerHeight / 2, cx = mx, cy = my;
    addEventListener('pointermove', function (e) { mx = e.clientX; my = e.clientY; dot.style.transform = 'translate(' + mx + 'px,' + my + 'px)'; }, { passive: true });
    (function loop() { cx += (mx - cx) * .16; cy += (my - cy) * .16; cur.style.transform = 'translate(' + cx + 'px,' + cy + 'px)'; requestAnimationFrame(loop); })();
    document.addEventListener('pointerover', function (e) { if (e.target.closest && e.target.closest('a,button,[role=button],summary')) cur.classList.add('is-on'); });
    document.addEventListener('pointerout', function (e) { if (e.target.closest && e.target.closest('a,button,[role=button],summary')) cur.classList.remove('is-on'); });
  }
  function magnets(root) {
    if (!fine || reduce) return;
    $$('.cd-mag', root).forEach(function (b) {
      if (b._cdMag) return; b._cdMag = 1;
      b.addEventListener('pointermove', function (e) { var r = b.getBoundingClientRect(); b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * .25) + 'px,' + ((e.clientY - r.top - r.height / 2) * .35) + 'px)'; });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- WebGL hero helix ---------- */
  var heroP = { p: 0 };
  function heroGL(sec) {
    if (!sec || sec._cdGL || reduce || typeof window.THREE === 'undefined') return;
    var data = [];
    try { data = JSON.parse(sec.getAttribute('data-images') || '[]'); } catch (e) { data = []; }
    if (!data.length) return;
    var canvas = $('.cd-hero__gl', sec), renderer;
    try { renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true }); } catch (e) { return; }
    sec._cdGL = 1;
    renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
    var scene = new THREE.Scene();
    scene.fog = new THREE.Fog(0x0f0c12, 7, 19);
    var cam = new THREE.PerspectiveCamera(42, 1, .1, 60);
    var group = new THREE.Group(); scene.add(group);
    var loader = new THREE.TextureLoader(); loader.setCrossOrigin('anonymous');
    var small = innerWidth < 760, N = data.length, R = 4.2, planes = [];
    var geo = new THREE.PlaneGeometry(1.9, 1.9, 16, 16), pos = geo.attributes.position;
    for (var i = 0; i < pos.count; i++) { var x = pos.getX(i); pos.setZ(i, -x * x * .08); }
    geo.computeVertexNormals();
    data.forEach(function (d, i) {
      var tex = loader.load(d.u); tex.encoding = THREE.sRGBEncoding; tex.anisotropy = 4;
      var mat = new THREE.MeshBasicMaterial({ map: tex, side: THREE.DoubleSide, transparent: true, opacity: 0 });
      var m = new THREE.Mesh(geo, mat), a = i / N * Math.PI * 2;
      m.position.set(Math.cos(a) * R, (i - N / 2) * .42, Math.sin(a) * R);
      m.lookAt(0, m.position.y, 0); m.rotateY(Math.PI);
      m.userData = { y: m.position.y, ph: Math.random() * 6.28, n: d.n, p: d.p };
      group.add(m); planes.push(m);
      if (G()) gsap.to(mat, { opacity: 1, duration: 1.4, delay: ($('#cdPre') ? 2.4 : .3) + i * .06 }); else mat.opacity = 1;
    });
    var cnt = small ? 260 : 600, arr = new Float32Array(cnt * 3);
    for (var k = 0; k < cnt; k++) { arr[k * 3] = (Math.random() - .5) * 22; arr[k * 3 + 1] = (Math.random() - .5) * 12; arr[k * 3 + 2] = (Math.random() - .5) * 16; }
    var dg = new THREE.BufferGeometry(); dg.setAttribute('position', new THREE.BufferAttribute(arr, 3));
    var dust = new THREE.Points(dg, new THREE.PointsMaterial({ color: 0xe8ab7c, size: .035, transparent: true, opacity: .75 }));
    scene.add(dust);
    var ring = new THREE.Mesh(new THREE.TorusGeometry(R + .9, .006, 8, 160), new THREE.MeshBasicMaterial({ color: 0xc8814f, transparent: true, opacity: .5 }));
    ring.rotation.x = Math.PI / 2; group.add(ring);
    function size() { var w = sec.clientWidth, h = sec.clientHeight; renderer.setSize(w, h, false); cam.aspect = w / h; cam.updateProjectionMatrix(); }
    size(); addEventListener('resize', size);
    var tx = 0, ty = 0, sx = 0, sy = 0, visible = true;
    addEventListener('pointermove', function (e) { tx = e.clientX / innerWidth - .5; ty = e.clientY / innerHeight - .5; }, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(sec);
    var hudN = $('[data-cd-hud-name]', sec), hudP = $('[data-cd-hud-price]', sec), last = -1, v = new THREE.Vector3(), clock = new THREE.Clock();
    sec.classList.add('cd-hero--gl');
    (function tick() {
      requestAnimationFrame(tick);
      if (!visible) return;
      var t = clock.getElapsedTime(), p = heroP.p;
      sx += (tx - sx) * .05; sy += (ty - sy) * .05;
      group.rotation.y = t * .08 + p * Math.PI * 1.6 + sx * .4;
      group.rotation.x = -.12 + sy * .15 + p * .35;
      group.position.x = small ? 0 : 2.4 - p * 2.4;
      cam.position.set(sx * 1.2, .6 - sy * .8 + p * 1.2, (small ? 12 : 10.5) - p * 6);
      cam.lookAt(group.position.x * .5, 0, 0);
      var best = 0, bz = -1e9;
      planes.forEach(function (m, i) { m.position.y = m.userData.y + Math.sin(t * .9 + m.userData.ph) * .12; m.getWorldPosition(v); if (v.z > bz) { bz = v.z; best = i; } });
      dust.rotation.y = t * .02;
      if (best !== last && hudN) { last = best; hudN.textContent = planes[best].userData.n || ''; hudP.textContent = planes[best].userData.p || ''; }
      renderer.render(scene, cam);
    })();
  }

  /* ---------- split headings ---------- */
  function splitHeads(root) {
    $$('.cd-split', root).forEach(function (h) {
      if (h._cdSplit) return; h._cdSplit = 1;
      var out = '';
      Array.prototype.forEach.call(h.childNodes, function (n) {
        var cls = n.nodeType === 1 ? (n.className || '') : '';
        (n.textContent || '').split(/(\s+)/).forEach(function (w) {
          if (!w || /^\s+$/.test(w)) { out += w; return; }
          var safe = w.replace(/&/g, '&amp;').replace(/</g, '&lt;');
          out += '<span class="cd-split-word"><span' + (cls ? ' class="' + cls + '"' : '') + '>' + safe + '</span></span>';
        });
      });
      h.innerHTML = out;
      if (G() && !reduce) gsap.from(h.querySelectorAll('.cd-split-word > span'), { yPercent: 110, rotate: 4, duration: 1.1, ease: 'expo.out', stagger: .05, scrollTrigger: { trigger: h, start: 'top 88%' } });
    });
  }

  /* ---------- scroll choreography ---------- */
  var mm = null, ctx = null;
  function choreo() {
    if (!G() || reduce) return;
    gsap.registerPlugin(ScrollTrigger);
    /* only revert what this function created last time — never other triggers (split headings, clocks) */
    if (mm) mm.revert();
    if (ctx) ctx.revert();
    ctx = gsap.context(choreoBody);
  }
  function choreoBody() {
    mm = gsap.matchMedia();

    var hero = $('[data-cd-hero]');
    if (hero) {
      ScrollTrigger.create({ trigger: hero, start: 'top top', end: 'bottom top', scrub: true, onUpdate: function (s) { heroP.p = s.progress; } });
      gsap.to($('.cd-wrap', hero), { yPercent: -18, opacity: .2, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
    }

    $$('.cd-rise').forEach(function (g) {
      gsap.from(g.children, { y: 60, rotateX: -25, opacity: 0, transformPerspective: 900, transformOrigin: '50% 100%', duration: 1.1, ease: 'expo.out', stagger: .08, scrollTrigger: { trigger: g, start: 'top 88%' } });
    });

    mm.add('(min-width: 900px)', function () {
      /* flying stack */
      $$('[data-cd-stack]').forEach(function (sec) {
        var slabs = $$('.cd-slab', sec), n = slabs.length; if (n < 2) return;
        var numEl = $('[data-cd-stack-n]', sec), nowEl = $('[data-cd-stack-now]', sec);
        if (nowEl) nowEl.textContent = slabs[0].getAttribute('data-name') || '';
        slabs.forEach(function (s, i) { gsap.set(s, { xPercent: -50, yPercent: -50, x: 0, y: -i * 26, z: -i * 170, rotateX: 8, rotateY: -14 + i * 2, opacity: 1 - i * .12, zIndex: n - i }); });
        var tl = gsap.timeline({ scrollTrigger: { trigger: sec, start: 'top top', end: '+=' + (n * 520), scrub: 1, pin: true, anticipatePin: 1,
          onUpdate: function (st) { var k = Math.min(n - 1, Math.floor(st.progress * n)); if (numEl) numEl.textContent = pad(k + 1); if (nowEl) nowEl.textContent = slabs[k].getAttribute('data-name') || ''; } } });
        slabs.forEach(function (s, i) {
          if (i === n - 1) return;
          tl.to(s, { z: 900, y: -80, rotateX: -30, rotateY: 22, opacity: 0, duration: 1, ease: 'power2.in' }, i);
          slabs.slice(i + 1).forEach(function (r, j) { tl.to(r, { z: -j * 170, y: -j * 26, rotateY: -14 + j * 2, opacity: 1 - j * .12, duration: 1, ease: 'power2.out' }, i); });
        });
        tl.to({}, { duration: .6 });
      });

      /* turning drum */
      $$('[data-cd-drum-sec]').forEach(function (sec) {
        var drum = $('[data-cd-drum]', sec); if (!drum) return;
        placeFaces(drum, 30);
        gsap.fromTo(drum, { rotateY: 20, rotateX: -6 }, { rotateY: -340, rotateX: 6, ease: 'none', scrollTrigger: { trigger: sec, start: 'top 70%', end: 'bottom 10%', scrub: 1 } });
      });

      /* sliding corridor */
      $$('[data-cd-corridor]').forEach(function (sec) {
        var lane = $('[data-cd-lane]', sec), bar = $('[data-cd-lane-bar]', sec); if (!lane) return;
        var dist = function () { return Math.max(0, lane.scrollWidth - innerWidth + 60); };
        var cards = $$('.cd-card', lane), skew = cards.length ? gsap.quickTo(cards, 'skewX', { duration: .5, ease: 'power3' }) : null;
        gsap.to(lane, { x: function () { return -dist(); }, ease: 'none', scrollTrigger: { trigger: sec, start: 'top top', end: function () { return '+=' + dist(); }, scrub: 1, pin: true, invalidateOnRefresh: true,
          onUpdate: function (st) { if (bar) bar.style.transform = 'scaleX(' + st.progress + ')'; if (skew) skew(gsap.utils.clamp(-8, 8, st.getVelocity() / -260)); } } });
      });

      /* 3D tilt */
      $$('.cd-tilt').forEach(function (c) {
        c.addEventListener('pointermove', function (e) { var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5; gsap.to(c, { rotateY: x * 12, rotateX: -y * 12, y: -6, transformPerspective: 900, duration: .5, ease: 'power3.out' }); });
        c.addEventListener('pointerleave', function () { gsap.to(c, { rotateY: 0, rotateX: 0, y: 0, duration: .8, ease: 'elastic.out(1,.5)' }); });
      });
    });

    mm.add('(max-width: 899px)', function () {
      $$('[data-cd-drum]').forEach(function (drum) { placeFaces(drum, 20); gsap.to(drum, { rotateY: -360, duration: 40, repeat: -1, ease: 'none' }); });
      $$('[data-cd-deck]').forEach(function (d) { gsap.from($$('.cd-slab', d), { y: 50, rotateX: -20, opacity: 0, duration: 1, stagger: .08, ease: 'expo.out', scrollTrigger: { trigger: d, start: 'top 85%' } }); });
    });

    $$('.cd-par, .cd-band__bg').forEach(function (b) { gsap.fromTo(b, { yPercent: -8 }, { yPercent: 8, ease: 'none', scrollTrigger: { trigger: b.parentNode, start: 'top bottom', end: 'bottom top', scrub: true } }); });
    $$('.cd-band').forEach(function (b) { var im = $('.cd-band__bg img', b); if (im) gsap.from(im, { scale: 1.25, ease: 'none', scrollTrigger: { trigger: b, start: 'top bottom', end: 'bottom top', scrub: true } }); });
    $$('.cd-reveal').forEach(function (r) { gsap.fromTo(r, { clipPath: 'inset(18% 12% 18% 12% round 28px)' }, { clipPath: 'inset(0% 0% 0% 0% round 28px)', duration: 1.4, ease: 'expo.out', scrollTrigger: { trigger: r, start: 'top 85%' } }); });
    $$('.cd-cnt').forEach(function (c) { var to = parseFloat(c.getAttribute('data-to')) || 0, o = { v: 0 }; gsap.to(o, { v: to, duration: 1.6, ease: 'power2.out', scrollTrigger: { trigger: c, start: 'top 90%' }, onUpdate: function () { c.textContent = Math.round(o.v); } }); });
    $$('[data-cd-plane]').forEach(function (p) { gsap.fromTo(p, { rotateX: 30, rotateZ: -5 }, { rotateX: 6, rotateZ: -1, ease: 'none', scrollTrigger: { trigger: p.parentNode, start: 'top bottom', end: 'bottom top', scrub: true } }); });
    var big = $('.cd-footer__big'); if (big) gsap.from(big, { yPercent: 40, opacity: 0, duration: 1.4, ease: 'expo.out', scrollTrigger: { trigger: big, start: 'top 95%' } });

    requestAnimationFrame(function () { ScrollTrigger.refresh(); });
  }
  function placeFaces(drum, extra) {
    var faces = $$('.cd-face', drum); if (!faces.length) return;
    var w = drum.offsetWidth, rad = Math.round(w / (2 * Math.tan(Math.PI / faces.length))) + extra;
    faces.forEach(function (f, i) { f.style.transform = 'rotateY(' + (i * 360 / faces.length) + 'deg) translateZ(' + rad + 'px)'; });
  }

  /* ---------- static drum layout when motion is off ---------- */
  function drumStatic() { if (!G() || reduce) $$('[data-cd-drum]').forEach(function (d) { placeFaces(d, 20); }); }

  /* ---------- deals clock (to midnight, visitor time) ---------- */
  function clocks() {
    var els = $$('[data-cd-clock]'); if (!els.length) return;
    var prev = {};
    function tick() {
      var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
      var s = Math.max(0, Math.floor((end - now) / 1000)), v = { h: pad(Math.floor(s / 3600)), m: pad(Math.floor(s % 3600 / 60)), s: pad(s % 60) };
      els.forEach(function (c, ci) {
        Object.keys(v).forEach(function (u) {
          var el = c.querySelector('[data-u="' + u + '"]'), key = ci + u;
          if (el && prev[key] !== v[u]) { el.textContent = v[u]; prev[key] = v[u]; if (!reduce) { el.classList.remove('is-flip'); void el.offsetWidth; el.classList.add('is-flip'); } }
        });
      });
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- quick add (falls back to normal form post) ---------- */
  function quickAdd() {
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f.matches || !f.matches('[data-cd-add]') || !window.fetch) return;
      e.preventDefault();
      var btn = f.querySelector('.cd-add');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
        .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (btn) { btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 900); }
          $$('[ref="cartBubbleCount"], .cart-bubble__text-count').forEach(function (el) { el.textContent = cart.item_count; });
          $$('[ref="cartBubble"], .cart-bubble').forEach(function (el) { el.classList.remove('visually-hidden', 'hidden'); el.removeAttribute('hidden'); });
        })
        .catch(function () { f.submit(); });
    });
  }

  /* ---------- flash sale board ---------- */
  function flashBoards(root) {
    $$('[data-cd-flash]', root).forEach(function (b) {
      if (b._cdFlash) return; b._cdFlash = 1;
      var live = b.getAttribute('data-mode') === 'live';
      var end, start;
      if (live) { end = new Date(parseInt(b.getAttribute('data-end'), 10) * 1000); start = new Date(parseInt(b.getAttribute('data-start'), 10) * 1000); }
      var left = $('[data-cd-flash-left]', b), bar = $('[data-cd-flash-bar]', b), prev = {};
      function setD(k, ch) { var el = b.querySelector('[data-d="' + k + '"]'); if (!el || prev[k] === ch) return; prev[k] = ch; el.innerHTML = '<span>' + ch + '</span>'; if (!reduce) { el.classList.remove('is-flip'); void el.offsetWidth; el.classList.add('is-flip'); } }
      function tick() {
        var now = new Date();
        if (!live) { end = new Date(now); end.setHours(24, 0, 0, 0); start = new Date(now); start.setHours(0, 0, 0, 0); }
        var s = Math.max(0, Math.floor((end - now) / 1000));
        var v = { d: Math.floor(s / 86400), h: live ? Math.floor(s % 86400 / 3600) : Math.floor(s / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
        Object.keys(v).forEach(function (k) { var p2 = pad(Math.min(99, v[k])); setD(k + '0', p2[0]); setD(k + '1', p2[1]); });
        var done = Math.min(1, Math.max(0, (now - start) / (end - start)));
        if (bar) bar.style.transform = 'scaleX(' + done + ')';
        if (left) left.textContent = Math.round((1 - done) * 100) + '% of the sale window left';
        if (live && s === 0 && !b._cdDone) { b._cdDone = 1; setTimeout(function () { location.reload(); }, 1500); }
      }
      tick(); setInterval(tick, 1000);
      if (G() && !reduce) gsap.from($$('.cd-fd', b), { rotateX: -90, opacity: 0, transformPerspective: 500, duration: .9, stagger: .04, ease: 'back.out(1.6)', scrollTrigger: { trigger: b, start: 'top 80%' } });
    });
  }

  /* ---------- tabbed products ---------- */
  function tabs(root) {
    $$('[data-cd-tabs]', root).forEach(function (sec) {
      if (sec._cdTabs) return; sec._cdTabs = 1;
      var btns = $$('[role=tab]', sec);
      btns.forEach(function (bt) {
        bt.addEventListener('click', function () {
          btns.forEach(function (x) { var on = x === bt; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on); });
          $$('[role=tabpanel]', sec).forEach(function (p) {
            var show = p.id === bt.getAttribute('aria-controls'); p.hidden = !show;
            if (show && G() && !reduce) { gsap.from($$('.cd-card', p), { y: 40, rotateX: -20, opacity: 0, transformPerspective: 900, duration: .8, stagger: .06, ease: 'expo.out' }); ScrollTrigger.refresh(); }
          });
        });
      });
    });
  }

  /* ---------- recently viewed (localStorage, per visitor) ---------- */
  var RV_KEY = 'cd_recent_v1';
  function rvRead() { try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]') || []; } catch (e) { return []; } }
  function rvWrite(list) { try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (e) {} }
  function recordView() {
    var el = $('#cdViewed'); if (!el) return;
    var item; try { item = JSON.parse(el.textContent); } catch (e) { return; }
    var list = rvRead().filter(function (x) { return x.h !== item.h; });
    list.unshift(item); rvWrite(list.slice(0, 10));
  }
  function recent(root) {
    $$('[data-cd-recent]', root).forEach(function (sec) {
      var row = $('[data-cd-recent-row]', sec), cur = ($('#cdViewed') ? JSON.parse($('#cdViewed').textContent).h : '');
      var list = rvRead().filter(function (x) { return x.h !== cur; }).slice(0, 8);
      if (!list.length) { sec.hidden = true; return; }
      row.innerHTML = '';
      list.forEach(function (x) {
        var a = document.createElement('a'); a.className = 'cd-rc'; a.href = x.u;
        var im = document.createElement('img'); im.src = x.i || ''; im.alt = ''; im.loading = 'lazy';
        var d = document.createElement('div'), t = document.createElement('b'), p = document.createElement('span');
        t.textContent = x.t; p.textContent = x.p; d.appendChild(t); d.appendChild(p); a.appendChild(im); a.appendChild(d); row.appendChild(a);
      });
      sec.hidden = false;
      var clr = $('[data-cd-recent-clear]', sec);
      if (clr && !clr._cd) { clr._cd = 1; clr.addEventListener('click', function () { rvWrite([]); sec.hidden = true; }); }
    });
  }

  /* ---------- newsletter pop-up ---------- */
  function popup() {
    var pop = $('[data-cd-pop]'); if (!pop) return;
    var seen = false, KEY = 'cd_pop_seen';
    try { seen = sessionStorage.getItem(KEY) === '1' || localStorage.getItem(KEY + '_joined') === '1'; } catch (e) {}
    if (/[?&]customer_posted=true/.test(location.search) || location.hash === '#CdPopForm') { try { localStorage.setItem(KEY + '_joined', '1'); } catch (e) {} pop.classList.add('is-on'); pop.setAttribute('aria-hidden', 'false'); }
    var last = null;
    function open() { if (seen) return; seen = true; try { sessionStorage.setItem(KEY, '1'); } catch (e) {} last = document.activeElement; pop.classList.add('is-on'); pop.setAttribute('aria-hidden', 'false'); var i = $('input[type=email]', pop); if (i) i.focus({ preventScroll: true }); }
    function close() { pop.classList.remove('is-on'); pop.setAttribute('aria-hidden', 'true'); if (last && last.focus) last.focus({ preventScroll: true }); }
    setTimeout(open, (parseInt(pop.getAttribute('data-delay'), 10) || 14) * 1000);
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 8) open(); });
    $$('[data-cd-pop-close]', pop).forEach(function (x) { x.addEventListener('click', close); });
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-on')) close(); });
  }

  /* ---------- extra entrances ---------- */
  var xctx = null;
  function extras() {
    if (!G() || reduce) return;
    if (xctx) xctx.revert();
    xctx = gsap.context(extrasBody);
  }
  function extrasBody() {
    $$('[data-cd-process]').forEach(function (p) { gsap.from($$('.cd-step', p), { rotateY: 55, x: 80, opacity: 0, transformPerspective: 1200, transformOrigin: '0% 50%', duration: 1.2, stagger: .14, ease: 'expo.out', scrollTrigger: { trigger: p, start: 'top 85%' } }); });
    $$('[data-cd-bento]').forEach(function (b) { gsap.from($$('.cd-bc', b), { y: 70, rotateX: -18, opacity: 0, transformPerspective: 1100, duration: 1.1, stagger: .07, ease: 'expo.out', scrollTrigger: { trigger: b, start: 'top 85%' } }); });
  }

  /* ---------- scroll container ----------
     Horizon 4.2 scrolls inside .page-wrapper on desktop (>=990px, html/body overflow hidden) and the window on
     mobile. ScrollTrigger listens to the window by default, so on desktop nothing below the hero ever revealed.
     Point every trigger at the real scroller; reload if the layout crosses the breakpoint. */
  var SQUEEZE = matchMedia('(min-width: 990px)');
  function pageScroller() {
    var w = document.querySelector('.page-wrapper');
    return (w && SQUEEZE.matches && getComputedStyle(w).overflowY !== 'visible') ? w : window;
  }
  function setScroller() {
    if (!G()) return;
    ScrollTrigger.defaults({ scroller: pageScroller() });
    if (SQUEEZE.addEventListener) SQUEEZE.addEventListener('change', function () { location.reload(); });
  }

  /* ---------- boot ---------- */
  function boot() {
    if (G()) { gsap.registerPlugin(ScrollTrigger); setScroller(); }
    splitHeads(document);
    magnets(document);
    heroGL($('[data-cd-hero]'));
    flashBoards(document);
    tabs(document);
    recent(document);
    choreo();
    extras();
    drumStatic();
  }
  function start() {
    recordView(); cursor(); clocks(); quickAdd(); popup(); intro(); boot();
    addEventListener('load', function () { if (G()) ScrollTrigger.refresh(); });
    /* theme editor: re-run when a section is added or changed */
    document.addEventListener('shopify:section:load', function (e) { splitHeads(e.target); magnets(e.target); heroGL($('[data-cd-hero]', e.target)); flashBoards(e.target); tabs(e.target); recent(e.target); choreo(); extras(); drumStatic(); });
    document.addEventListener('shopify:section:unload', function () { setTimeout(choreo, 50); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
